import { computed, action, runInAction } from 'mobx'
import { Store } from 'libx'
import QuovoAPI from 'misc/QuovoAPI'
import { QuovoLinkedAccount, PlaidLinkedAccount } from 'domain/LinkedAccount'

export default class LinkedAccountStore extends Store {
  constructor () {
    super(...arguments)

    this.linkedAccounts = this.collection({
      mapperFn: (json) =>
        json.provider === 'quovo'
          ? new QuovoLinkedAccount(json, { rootStore: this.rootStore, parse: true })
          : new PlaidLinkedAccount(json, { rootStore: this.rootStore, parse: true })
    })
  }

  @computed get quovoAPI () {
    return QuovoAPI.create(this.rootStore.authStore.token)
  }

  @action addAccount (account) {
    // Accounts are created by designated providers, so no async going
    // on here.
    this.linkedAccounts.items.add(account)
  }

  async fetchLinkedAccounts () {
    const quovoAccounts = await this.rootStore.retryOnNetworkFailure(() => this.quovoAPI.getAccounts().then((data) =>
      data.accounts.map((a) => ({ ...a, provider: 'quovo' }))
    ))
      .retryMessage('Could not load linked accounts, retrying...')
      .recoveredMessage('.. and we\'re back in business!')
      .networkIssueMessage('Linked account system is unreachable.')

    if (quovoAccounts !== false) {
      runInAction(() =>
        this.linkedAccounts.set(quovoAccounts)
      )
    }

    return this.linkedAccounts
  }

  async destroy (account) {
    if (account instanceof PlaidLinkedAccount) {
      this.linkedAccounts.remove(account)
      return
    }

    const success = await this.rootStore.retryOnNetworkFailure(() => this.quovoAPI.deleteAccount(account.id))
      .retryMessage('Network issue while deleting linked account, retrying...')
      .networkIssueMessage('Linked account system is unreachable.')
    if (success === false) {
      return
    }
    runInAction(() => {
      this.linkedAccounts.remove(account)
    })
  }
}



// WEBPACK FOOTER //
// ./src/client/store/LinkedAccountStore.js